import React from 'react';
import { getStatus, CLS_STYLES } from '../lib/utils';

export default function StatusPill({ submission }) {
  const cfg   = getStatus(submission.status);
  const style = CLS_STYLES[cfg.cls] || CLS_STYLES.gray;
  return (
    <span style={{
      display:'inline-flex', alignItems:'center', gap:5,
      padding:'3px 10px', borderRadius:3,
      fontSize:10, fontWeight:500, letterSpacing:'0.06em', textTransform:'uppercase',
      background:style.bg, color:style.color, border:`1px solid ${style.border}`,
      whiteSpace:'nowrap',
    }}>
      <span style={{ width:5, height:5, borderRadius:'50%', background:'currentColor' }}/>
      {cfg.label}
    </span>
  );
}